import config from '../config';

export interface UrlInfoParent {
  type: string;
  id: string;
}

export interface UrlInfo {
  service: string;
  id: string;
  parent: '' | UrlInfoParent;
}

export function getUrlInfo(url?: string, skip = 0): UrlInfo {
  let service = '';
  let parent: '' | UrlInfoParent = '';
  let id = '';
  if (url) {
    const stripped = url.split('?')[0].replace(/(.?services)?(.?\d+\.\d+)?/, '');
    const split = stripped.split('/');
    if ((split.length - skip) % 2 !== 0) {
      id = split[split.length - 1 - skip];
      service = split[split.length - 2 - skip];
    } else {
      service = split[split.length - 1 - skip];
      if (split.length > 3 + skip) {
        parent = {
          type: split[split.length - 3 - skip],
          id: split[split.length - 2 - skip],
        };
      }
    }
  }
  return { service, id, parent };
}

export function getServiceVersion(service?: string): string | undefined {
  if (service && config.serviceVersion) {
    if (config.serviceVersion[service]) {
      return config.serviceVersion[service];
    }
    return config.serviceVersion.default;
  }
  return undefined;
}
